import VeliPlayGameContainer from './container/VeliPlayGameContainer';

export default VeliPlayGameContainer;
